export const ONE_DEMAND_CATEGORY = 'OneDemand';

export const isOneDemandCategory = (category) => category === 'Client' || category === ONE_DEMAND_CATEGORY;

/** API category key → UI label (OneDemand displays as 1Demand) */
export const getCategoryDisplayName = (category) =>
    category === ONE_DEMAND_CATEGORY ? '1Demand' : category || '';
